import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import SourceOutlinedIcon from '@mui/icons-material/SourceOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';
import { SHOW_NEWS_AGENT, SHOW_NEWS_SOURCES } from '../../config/app';

/** Shared drawer widths — always wide enough for icon + label text */
export const DRAWER_WIDTH = {
  xs: 288,
  md: 260,
  lg: 288,
};

/** Page horizontal padding — roomy enough for older readers on a phone */
export const PAGE_GUTTER = {
  xs: 2,
  sm: 2.5,
  md: 3,
  lg: 3.5,
};

/** Vertical rhythm between page sections */
export const PAGE_STACK_SPACING = {
  xs: 2,
  sm: 2.5,
  md: 3,
};

/** Mobile quick nav — browse only (staff tools stay in the drawer). */
export function getMobileQuickNavItems() {
  return [
    { to: '/', label: 'Feed', icon: ArticleOutlinedIcon, end: true },
    { to: '/alerts', label: 'Alerts', icon: NotificationsNoneIcon },
    { to: '/profile', label: 'Profile', icon: PersonOutlineIcon },
  ];
}

/**
 * Build sidebar sections from auth state.
 * Guests and readers share Browse. Staff get extra admin links after login.
 */
export function getSidebarNav({
  isStaff,
  canComposeAlerts,
  canManageSources,
  canManageUsers,
  canViewAnalytics,
}) {
  const browse = [
    { to: '/', label: 'Feed', icon: ArticleOutlinedIcon, end: true },
    { to: '/alerts', label: 'Alerts', icon: NotificationsNoneIcon },
    { to: '/profile', label: 'Profile', icon: PersonOutlineIcon },
  ];

  const staff = isStaff
    ? [
        {
          to: '/admin',
          label: 'Dashboard',
          icon: DashboardOutlinedIcon,
          end: true,
        },
        { to: '/admin/content', label: 'Content', icon: EditNoteOutlinedIcon },
        ...(SHOW_NEWS_AGENT && canManageSources
          ? [
              {
                to: '/admin/intake',
                label: 'Scrape',
                icon: SourceOutlinedIcon,
              },
            ]
          : []),
        ...(SHOW_NEWS_SOURCES
          ? [
              {
                to: '/admin/sources',
                label: 'News sources',
                icon: SourceOutlinedIcon,
              },
            ]
          : []),
        ...(canViewAnalytics
          ? [
              {
                to: '/admin/analytics',
                label: 'Analytics',
                icon: InsightsOutlinedIcon,
              },
            ]
          : []),
        ...(canManageUsers
          ? [{ to: '/admin/users', label: 'Users', icon: PeopleOutlinedIcon }]
          : []),
        ...(canComposeAlerts
          ? [
              {
                to: '/admin/alerts',
                label: 'Compose alerts',
                icon: CampaignOutlinedIcon,
              },
            ]
          : []),
      ]
    : [];

  return [
    { id: 'browse', title: 'Browse', items: browse },
    ...(staff.length
      ? [{ id: 'staff', title: 'Staff tools', items: staff }]
      : []),
  ];
}
